export default __webpack_public_path__ + "static/banner2-934414e2dd5aa7026df810dcca058279.jpg";